import React, { useEffect } from 'react';
const ICACTEA_2026 = () => {
  useEffect(() => {
    window.location.href = 'https://www.geeksforgeeks.org/hack-a-thon/digital-campus-on-google-cloud-hack-sprint-aditya-university';
  }, [])
  return (
  <></>    
  )
}

export default ICACTEA_2026;



